module.exports = __webpack_public_path__ + "media/svg/gd-7391bfd0.svg";